// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_oa-0";
export var animationContainer = "_oa-1";
export var itemPrice = "_oa-a";
export var itemizedContent = "_oa-9";
export var itemizedHeader = "_oa-7";
export var itemizedRow = "_oa-8";
export var itemizedSection = "_oa-6";
export var modalContent = "_oa-2";
export var orderName = "_oa-3";
export var refundOption = "_oa-4";
export var refundOptionsContainer = "_oa-5";
export var shippingLabel = "_oa-b";
export var totalRow = "_oa-c";